import { AuthProvider } from "@/providers/AuthProvider";
import { ThemeProvider } from "@/providers/ThemeProvider";
import { PropsWithChildren } from "react";
import { StorageProvider } from "@/providers/StorageProvider";
import { RealtimeProvider } from "@/providers/RealtimeProvider";
import { ContextMenuProvider } from "@/providers/ContextMenuProvider";
import { ToastProvider } from "@/providers/ToastProvider";
import { ModalProvider } from "@/providers/ModalProvider";
import { NavGuardProvider } from "@/providers/NavGuardProvider";
import { ToolTipProvider } from "./ToolTipProvider";
import { HintProvider } from "./HintProvider";
import { DateTimeProvider } from "@/providers/DateTimeProvider";
import { CallProvider } from "./CallsProvider";
import { RowSelectionProvider } from "@/providers/RowSelectionProvider";
import { BadgeProvider } from "@/providers/BadgeProvider";
import { PermissionsProvider } from "@/providers/PermissionsProvider";
import { SMSProvider } from "@/providers/SMSProvider";
import { DrawerCacheProvider } from "@/providers/DrawerCacheProvider";
import { EntityTablePageProvider } from "@/providers/EntityTablePageProvider";
import { UpdateProvider } from "@/providers/UpdateProvider";
// TODO: Re-enable when .md import is resolved
// import { SystemMessageProvider } from "@/providers/SystemMessageProvider";

export const AppProvider = ({ children }: PropsWithChildren) => {
  return (
    <StorageProvider>
      <AuthProvider>
        <DrawerCacheProvider>
          <DateTimeProvider>
            <ThemeProvider>
              <ModalProvider>
                <UpdateProvider>
                  {/* TODO: Re-enable SystemMessageProvider when .md import is resolved */}
                  <NavGuardProvider>
                    <ToastProvider>
                      <RealtimeProvider>
                        <SMSProvider>
                          <HintProvider>
                            <CallProvider>
                              <ContextMenuProvider>
                                <ToolTipProvider>
                                  <PermissionsProvider>
                                    <BadgeProvider>
                                      <RowSelectionProvider>
                                        <EntityTablePageProvider>{children}</EntityTablePageProvider>
                                      </RowSelectionProvider>
                                    </BadgeProvider>
                                  </PermissionsProvider>
                                </ToolTipProvider>
                              </ContextMenuProvider>
                            </CallProvider>
                          </HintProvider>
                        </SMSProvider>
                      </RealtimeProvider>
                    </ToastProvider>
                  </NavGuardProvider>
                </UpdateProvider>
              </ModalProvider>
            </ThemeProvider>
          </DateTimeProvider>
        </DrawerCacheProvider>
      </AuthProvider>
    </StorageProvider>
  );
};
